// src/utils/cryptApiBody.ts

import CryptoJS from 'crypto-js';

const secretKey = CryptoJS.SHA256(process.env.REACT_APP_FOR_API_BODY_ENCRYPTION_SECRET_KEY!);
const secretIv = CryptoJS.MD5(process.env.REACT_APP_FOR_API_BODY_ENCRYPTION_SECRET_IV!);

const secretKeyWordPress = CryptoJS.SHA256(process.env.REACT_APP_FOR_API_BODY_ENCRYPTION_WORDPRESS_SECRET_KEY!);
const secretIvWordPress = CryptoJS.MD5(process.env.REACT_APP_FOR_API_BODY_ENCRYPTION_WORDPRESS_SECRET_IV!);

/**
 * Encrypt a string using AES
 */
function encryptApiBodyFromString (text= ''): string {
    try {
        text = text.toString();
        if (text.length > 0) {
            const encrypted = CryptoJS.AES.encrypt(text, secretKey, {
                iv: secretIv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7,
            });
            return encrypted.toString(); // returns Base64 string
        } else {
            return text;
        }
    } catch (e) {
        return '';
    }

}

/**
 * Decrypt an encrypted string
 */
function decryptApiBodyToString (encryptedText = ''): string {
    if (encryptedText && encryptedText !== '') {
        try {
            const decrypted = CryptoJS.AES.decrypt(encryptedText, secretKey, {
                iv: secretIv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7,
            });
            return decrypted.toString(CryptoJS.enc.Utf8);
        } catch (e: any) {
            // Erreur de decrypt
        }
    }
    return '';
}



/**
 * Encrypt a string using AES
 */
function encryptApiBodyFromStringWordPress (text= ''): string {
    try {
        text = text.toString();
        if (text.length > 0) {
            const encrypted = CryptoJS.AES.encrypt(text, secretKeyWordPress, {
                iv: secretIvWordPress,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7,
            });
            return encrypted.toString(); // returns Base64 string
        } else {
            return text;
        }
    } catch (e) {
        return '';
    }

}

/**
 * Decrypt an encrypted string
 */
function decryptApiBodyToStringWordPress (encryptedText = ''): string {
    if (encryptedText && encryptedText !== '') {
        try {
            const decrypted = CryptoJS.AES.decrypt(encryptedText, secretKeyWordPress, {
                iv: secretIvWordPress!,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7,
            });
            return decrypted.toString(CryptoJS.enc.Utf8);
        } catch (e: any) {
            // Erreur de decrypt
        }
    }
    return '';
}


/**
 * Encrypt a json using AES
 */
function encryptApiBodyFromJSON (json: any): string {
    try {
        const text = JSON.stringify(json);
        const encrypted = CryptoJS.AES.encrypt(text, secretKey, {
            iv: secretIv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        });
        return encrypted.toString(); // returns Base64 string
    } catch (e) {
        return '';
    }
}

/**
 * Encrypt a json using AES
 */
function encryptApiBodyFromFormData(formData: FormData): any {
    let body = JSON.stringify(Object.fromEntries(formData));
    return encryptApiBodyFromJSON(JSON.parse(body));
}

/**
 * Decrypt an encrypted string
 */
function decryptApiBodyToJson (encryptedText?: string): any {
    if (encryptedText && encryptedText !== '') {
        try {
            const decrypted = CryptoJS.AES.decrypt(encryptedText, secretKey, {
                iv: secretIv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7,
            });
            return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
        } catch (e: any) {
            //
        }
    }
    return {};
}


export { encryptApiBodyFromString, decryptApiBodyToString, decryptApiBodyToJson, encryptApiBodyFromJSON, encryptApiBodyFromFormData, decryptApiBodyToStringWordPress, encryptApiBodyFromStringWordPress };
